import { Injectable } from '@angular/core';
import { FormElement } from '../model/form-element.model';
import { IFormElements } from './iform-elements.service';
import { ApiService, ApiCacheOptions, PagedSearch, PagedResult } from '../../../shared/index';

@Injectable()
export class FormElements implements IFormElements {
  private _apiService: ApiService;
  private _cacheOptions: ApiCacheOptions;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
    this._cacheOptions = this._apiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
  }

  public getFormElementByElementType = (elementTypeId: number): Promise<any> => {
    //let cacheOptions: ApiCacheOptions = new ApiCacheOptions();
    //cacheOptions.DisableCaching = true;

    let url: string = '/Forms/Element/' + elementTypeId.toString();
    return this._apiService.get(url);
  };
}
